/**
 * 工作流配置
 * @author limy
 */
import api from '@/services/api'
import {METHOD, request} from '@/utils/request'

export const dataApi = {
  async indexData() {
    return request(api.index.INDEX_API + "/wechatMoments/getIndexDataGroupOne", METHOD.GET);
  },
  async listData(listData) {
    return request(api.index.INDEX_API_DATA + "/querySaleFunnel", METHOD.GET, listData)
  },
  async indexBriefingData(startDate, endDate,type,userNo) {
    return request(api.index.INDEX_API_DATA+"/queryCustSaleInfo", METHOD.GET, {startDate,endDate,type,userNo});
  },
  async getStrainList() { //品系
    return request(api.index.INDEX_API_DATA + "/getStrainList", METHOD.GET);
  },
  async getDeptList(userNo) { //经理部
    return request(api.index.INDEX_API_DATA + "/getDeptList?userNo=" + userNo, METHOD.GET);
  },
  async getDealerList(userNo, cityId,regionId) { //
    return request(api.index.INDEX_API_DATA + "/getDealerList?userNo=" + userNo + '&cityId=' + cityId + '&regionId=' + regionId, METHOD.GET);
  },
  async getCityList(deptId) { //
    return request(api.index.INDEX_API_DATA + "/getCityList?deptId=" + deptId, METHOD.GET);
  },
}

export default {dataApi}
